<template>
  <div class="l_body">
    <div class="l_head">登录</div>
    <div class="l_center">
      <div class="mbimg">
        <img
          src="../../../resource/img/yuanxingtupian.png"
          alt
          style="width：53.33%;height:21vh;position: relative;right: -5vh;"
        />
        <img
          src="../../../resource/img/gerenzhongxin-zhong.png"
          alt
          style="width：7.33%;height:10vh;position: relative;right:11vh;height: 10vh;top: -6vh"
        />
      </div>
      <div class="mbtittle">商家端</div>
      <div class="mbinput">
        <input type="text" class="toke-input" placeholder="账号" ref="num" value="hxmtest333"/>
        <input type="password" class="toke-input" placeholder="密码" ref="pwd" value="123456"/>
        <button class="toke-btn" @click="UserLogin">登录</button>
        <div style="margin-top:30px;">
          <img src="../../../resource/img/weixin.png" alt style="width:5vh;height:4vh;"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MerUnionmblogin',
  data () {
    return {
      user: [],
      token: ''
    }
  },
  methods: {
    UserLogin: function () {
      var that = this
      that.$axios
        .post(
          '/staff/wxapp/login.do',
          that.$qs.stringify({
            username: this.$refs.num.value,
            password: this.$refs.pwd.value,
            confirm: false
          })
        )
        .then(response => {
          that.user = response.data.user
          that.token = response.data.token
          if (response.data.msg == '登录成功') {
            that.$router.push({
              path: '/MerUnionmbmainpage',
              name: 'MerUnionmbmainpage',
              params: {
                user: that.user,
                token: that.token
              }
            })
          }
        })
        .catch(function (error) {
          //请求失败处理
          console.log(error)
        })
    }
  }
}
</script>
<style>
  .l_body {
    width: 100%;
    height: 96vh;
    background-image: url("../../../resource/img/khdloginbg.png");
    z-index: 8;
  }

  .l_head {
    width: 100%;
    line-height: 3;
    height: 15vh;
    text-align: center;
    /* line-height: 17vh; */
    font-size: 40px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }

  .l_center {
    width: 100%;
    height: 80vh;
    text-align: center;
  }

  .mbimg {
    width: 100%;
    height: 30%;
  }

  .mbtittle {
    width: 100%;
    height: 5vh;
    font-size: 28px;
    font-family: PingFangSC-Regular;
    color: rgba(159, 141, 198, 1);
    text-align: center;
    line-height: 5vh;
  }

  .mbinput {
    width: 100%;
    height: 40vh;
    text-align: center;
  }

  .toke-input {
    width: 71.07%;
    height: 6vh;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 55px;
    margin-top: 3vh;
    border: none;
    letter-spacing: 5px;
    padding-left: 0.34rem;
    font-family: PingFangSC-Medium;
    color: rgba(115, 115, 115, 1);
    font-size: 0.4rem;
  }

  .toke-btn {
    width: 71.07%;
    height: 6vh;
    margin-top: 3vh;
    border: none;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 55px;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    font-size: 0.4rem;
    margin-top: 7vh;
  }

  /* input::-webkit-input-placeholder{
  font-size:32px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(115,115,115,1);
  line-height:45px;
  margin-left: 25px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/active/member/MerUnionmblogin.vue